module.exports = __webpack_public_path__ + "img/flag_rect_110.61a468c7.png";